/**
 * @flow
 * @relayHash ac570f0fe48d6ca659da22c917d0f81a
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ArticleOrdering = "publishedAt_DESC" | "relevancy_DESC" | "%future added value";
export type searchPageQueryVariables = {|
  searchTerm?: ?string,
  orderBy?: ?ArticleOrdering,
|};
export type searchPageQueryResponse = {|
  +articles: $ReadOnlyArray<{|
    +slug: ?string,
    +title: ?string,
    +caption: ?string,
    +readingTime: ?number,
    +picture: ?string,
    +author: ?{|
      +firstname: ?string,
      +lastname: ?string,
    |},
    +city: ?{|
      +slug: string,
      +name: string,
      +color: ?string,
    |},
    +category: ?{|
      +slug: ?string,
      +name: ?string,
      +color: ?string,
    |},
  |}>
|};
export type searchPageQuery = {|
  variables: searchPageQueryVariables,
  response: searchPageQueryResponse,
|};
*/


/*
query searchPageQuery(
  $searchTerm: String
  $orderBy: ArticleOrdering
) {
  articles(searchTerm: $searchTerm, orderBy: $orderBy) {
    slug
    title
    caption
    readingTime
    picture
    author {
      firstname
      lastname
    }
    city {
      slug
      name
      color
    }
    category {
      slug
      name
      color
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "searchTerm",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderBy",
    "type": "ArticleOrdering",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "slug",
  "args": null,
  "storageKey": null
},
v2 = [
  v1,
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "name",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "color",
    "args": null,
    "storageKey": null
  }
],
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "articles",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "orderBy",
        "variableName": "orderBy",
        "type": "ArticleOrdering"
      },
      {
        "kind": "Variable",
        "name": "searchTerm",
        "variableName": "searchTerm",
        "type": "String"
      }
    ],
    "concreteType": "Article",
    "plural": true,
    "selections": [
      v1,
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "title",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "caption",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "readingTime",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "picture",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "author",
        "storageKey": null,
        "args": null,
        "concreteType": "Author",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "firstname",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "lastname",
            "args": null,
            "storageKey": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "city",
        "storageKey": null,
        "args": null,
        "concreteType": "City",
        "plural": false,
        "selections": v2
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "category",
        "storageKey": null,
        "args": null,
        "concreteType": "Category",
        "plural": false,
        "selections": v2
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "query",
  "name": "searchPageQuery",
  "id": null,
  "text": "query searchPageQuery(\n  $searchTerm: String\n  $orderBy: ArticleOrdering\n) {\n  articles(searchTerm: $searchTerm, orderBy: $orderBy) {\n    slug\n    title\n    caption\n    readingTime\n    picture\n    author {\n      firstname\n      lastname\n    }\n    city {\n      slug\n      name\n      color\n    }\n    category {\n      slug\n      name\n      color\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "searchPageQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v3
  },
  "operation": {
    "kind": "Operation",
    "name": "searchPageQuery",
    "argumentDefinitions": v0,
    "selections": v3
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '432ec7fceba4baefa19afd69352368b6';
module.exports = node;
